export default {
  'Content-Type': 'application/vnd.api+json',
};
